import { Component, OnInit } from '@angular/core';
import { routerTransition } from "../animations";
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class AboutComponent implements OnInit {

  public aboutText;
  public danURL;
  public adamURL;
  public nickURL;

  constructor(private af: AngularFireDatabase) { }

  ngOnInit() {
    this.af.object('/static/about').$ref.once("value").then(about => {
      this.aboutText = about.val();
    });

    var storage = firebase.storage();
    var storageRef = storage.ref();
    let that = this;
    storageRef.child('dan.jpg').getDownloadURL().then(function(url) {
      that.danURL = url;
    }).catch(function(error) {});
    storageRef.child('nick.jpg').getDownloadURL().then(function(url) {
      that.nickURL = url;
    }).catch(function(error) {});
    storageRef.child('adam.jpg').getDownloadURL().then(function(url) {
      that.adamURL = url;
    }).catch(function(error) {});
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/about/about.component.ts